/** Font/execution type: lettering (script text). */
export const FONT_TYPE_LETTERING = 'Lettering';

/** Font/execution type: single letters. */
export const FONT_TYPE_SINGLE_LETTERS = 'Einzelbuchstaben';

/** Letter spacing in mm by execution type: Lettering = 3mm, Einzelbuchstaben (single letters) = 6mm. */
export const SPACING_MM_BY_FONT_TYPE: Record<string, number> = {
  [FONT_TYPE_LETTERING]: 3,
  [FONT_TYPE_SINGLE_LETTERS]: 6,
};
